function middlewarePipeline(context: any, middleware: any, index: any) {
  const nextMiddleware = middleware[index];

  if (!nextMiddleware) {
    return context.next;
  }

  return (param: any) => {
    if (param) return context.next(param);

    const nextPipeline = middlewarePipeline(context, middleware, index + 1);

    // Return (don't fire-and-forget) so an async middleware keeps the router's
    // guard promise pending until the real next() is actually called — otherwise
    // vue-router sees the promise resolve with next never invoked and cancels
    // the navigation.
    return nextMiddleware({ ...context, next: nextPipeline });
  };
}

export default middlewarePipeline;
